import { Form } from "react-bootstrap"

// FilterSidebar now receives `filters` (the fixed 3 types) instead of the
// raw `clubs` derived list, so only TAEKWON-DO / KICKBOXING MUAY THAI /
// ZUMBA DANCE ever appear in the sidebar.
export default function FilterSidebar({ filters, selected, setSelected, searchQuery, setSearchQuery }) {

  const toggleFilter = (filterName) => {
    if (selected.includes(filterName))
      setSelected(selected.filter(c => c !== filterName))
    else
      setSelected([...selected, filterName])
  }

  const clearFilters = () => {
    setSelected([])
    setSearchQuery("")
  }

  return (
    <>
      <div className="filter-header">
        <h6 className="filter-title">Filter</h6>

        {(selected.length > 0 || searchQuery !== "") && (
          <button
            type="button"
            className="clear-filter-linkc border-0 bg-transparent p-0"
            onClick={clearFilters}
          >
            Clear Filter
          </button>
        )}
      </div>

      <div className="filter-checkboxes-box">
        {filters.map((filter) => (
          <Form.Check
            key={filter.id}
            type="checkbox"
            label={filter.name}
            checked={selected.includes(filter.name)}
            onChange={() => toggleFilter(filter.name)}
            className="filter-checkbox"
          />
        ))}
      </div>
    </>
  )
}